import React from "react";

export default function InformationRibonMobileV2(props) {
  return (
    <div className="ribon-information-mobile-v2">
      {props.infoLabel}: {props.labelContent}
    </div>
  );
}
